import { useEffect } from 'react';
import AccountPopOver from 'Components/common/components/AccountPopOver';

import { useDispatch, useSelector } from 'react-redux';

import { actions } from 'Slice/ServiceLinesSlice';
import ServiceLinesSvg from 'Components/layout/assets/ServiceLinesSvg';
import { IsTablet } from 'Utils/UtilityFunctions';
import { useNavigate } from 'react-router-dom';
import { selectServiceLinePermission, selectShowChatbot, selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import NavBarPrimary from '../../Components/layout/headers/NavBarPrimary';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import { ChatbotV2FullSkeleton, Gilroy } from '../../Components/gilroy/LazyGilroy';
import { useGilroy } from '../../Utils/hooks/useGilroy';
import { selectLoading, selectRecommendedServiceLines, selectServiceLines } from '../../Selector/ServiceLinesSelector';
import ServiceLinesSection from 'Components/servicelines/ServiceLinesSection';
import SLRecommended from 'Components/servicelines/SLRecommended';




const ServiceLinesHome = function ServiceLinesHome() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTab = IsTablet();
  const chatbotAllowed = useSelector(selectShowChatbot);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const loading = useSelector(selectLoading);
  const { gilroyStates, gilroyActions } = useGilroy();
  const recommendedSL = useSelector(selectRecommendedServiceLines);
  const followedSL = useSelector(selectServiceLines);
  const serviceLinePermission = useSelector(selectServiceLinePermission);

  useEffect(() => {
    window.scrollTo(0, 0);
    const hasServiceLineData = recommendedSL.length > 0 || followedSL.length > 0;
    if (!hasServiceLineData) {
      dispatch(actions.getServiceLines());
    }
  }, [dispatch, followedSL.length, recommendedSL.length]);

  useEffect(() => {
    if (!loading) {
      if (recommendedSL.length > 0 || followedSL.length > 0) {
        if (!serviceLinePermission) {
          navigate('/feed');
        }
      }
    }
  }, [recommendedSL, followedSL]);
  return (
    <>
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          <ServiceLinesSvg />
          <h1 className="heading">Service Lines</h1>
        </div>
        <div className="right-side-wrap">
          <GlobalSearch iconMode={isTab} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>

      </NavBarPrimary>
      <div className="container">

        {chatbotAllowed && showGlobalGilroy ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}


        <ServiceLinesSection />


        <SLRecommended />

      </div>

    </>
  );
};

export default ServiceLinesHome;